import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IApplicantInformation } from 'app/models/licenses/applicant-information';

@Injectable({ providedIn: 'root' })

export class ApplicantInformationService {
  private api: string = environment.privateApi + 'ApplicantInformation/';
  private http = inject(HttpClient);

  public getApplicantInformation(licenseMasterId: number): Observable<IApplicantInformation> {
    return this.http.get<IApplicantInformation>(this.api + 'GetApplicationInformation/' + licenseMasterId);
  }

  public saveApplicantInformation(applicantInfo: IApplicantInformation): Observable<number> {
    return this.http.post<number>(this.api + 'SaveApplicantInformation', applicantInfo);
  }

}
